import { render, staticRenderFns } from "./Notifier.vue?vue&type=template&id=4f9596d6"
import script from "./Notifier.vue?vue&type=script&lang=js"
export * from "./Notifier.vue?vue&type=script&lang=js"
import style0 from "./Notifier.vue?vue&type=style&index=0&id=4f9596d6&lang=sass"
import style1 from "./Notifier.vue?vue&type=style&index=1&id=4f9596d6&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9596d6')) {
      api.createRecord('4f9596d6', component.options)
    } else {
      api.reload('4f9596d6', component.options)
    }
    module.hot.accept("./Notifier.vue?vue&type=template&id=4f9596d6", function () {
      api.rerender('4f9596d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifier.vue"
export default component.exports